import { Injectable } from "@angular/core";
import { LocalStorageKey } from "@model";

@Injectable({ providedIn: "root" })
export class LocalStorageService {
  get(key: LocalStorageKey): string | null {
    return localStorage.getItem(key);
  }

  set(key: LocalStorageKey, value: string): void {
    return localStorage.setItem(key, value);
  }
}
